module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"like_text":"助かります","unlike_text":"役に立たない","already_submitted":"すでに選択されました。ページを更新してください:)","comment":"コメント"}}')
  delete Component.options._Ctor
}
